import React, { useState, useContext, useEffect, useRef } from 'react';
import { AiOutlineGlobal, AiFillCaretDown, AiOutlineCheck } from "react-icons/ai";
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../MainContext';


function ChangeLanguage(props) {
  const { t, i18n } = useTranslation();

  const isWide = useContext(mainContext).isWide;
  const langCode = useContext(mainContext).langCode;
  const setLangCode = useContext(mainContext).setLangCode;

  const isBottom = useContext(mainContext).isBottom;
  const footerWrapHeight = useContext(mainContext).footerWrapHeight;
  const footerHeight = useContext(mainContext).footerHeight;

  const [isOpen, setIsOpen] = useState(false);
  const [bottom, setBottom] = useState(0);



  useEffect(() => {
    if(isWide) {
      setBottom(30);
    } else {
      // SP
      if(isBottom) {
        // 1番下までスクロールされている状態
        setBottom(footerWrapHeight+footerHeight+5);
      } else {
        setBottom(footerWrapHeight+5);
      }
    }
  }, [isWide, isBottom, footerWrapHeight, footerHeight])



  const onPressLanguage = () => {
    setIsOpen(!isOpen);
  }

  // 英語
  const onPressEn = () => {
    setLangCode('en');
    setIsOpen(false);
  }
  // 日本語
  const onPressJa = () => {
    setLangCode('ja');
    setIsOpen(false);
  }
  // 中国語
  const onPressCn = () => {
    setLangCode('zh-CN');
    setIsOpen(false);
  }
  // 韓国
  const onPressKo = () => {
    setLangCode('ko');
    setIsOpen(false);
  }



  return (
    <>
      <div
        className={styles.wrap}
        style={{bottom: bottom}}
      >

        <div
          className={`
            ${styles.langWrap}
            ${isOpen? styles.openWrap : styles.closeWrap}
          `}
          onClick={onPressLanguage}
        >
          <AiOutlineGlobal
            size={isWide? '1em' : '0.8em'}
            color={'white'}
          />
          <p className={styles.langTitle}>Lang</p>
          <AiFillCaretDown
            size={isWide? '0.7em' : '0.5em'}
            color={'white'}
          />
        </div>

        {isOpen &&
        <>
          <div
            className={styles.btn}
            onClick={onPressJa}
          >
            {langCode=='ja' &&
              <AiOutlineCheck
                size={isWide? '1em' : '0.7em'}
                color={'white'}
              />
            }
            <p className={styles.btnTxt}>日本語</p>
          </div>

          <div
            className={styles.btn}
            onClick={onPressEn}
          >
            {langCode=='en' &&
              <AiOutlineCheck
                size={isWide? '1em' : '0.7em'}
                color={'white'}
              />
            }
            <p className={styles.btnTxt}>ENGLISH</p>
          </div>

          <div
            className={styles.btn}
            onClick={onPressCn}
          >
            {langCode=='zh-CN' &&
              <AiOutlineCheck
                size={isWide? '1em' : '0.7em'}
                color={'white'}
              />
            }
            <p className={styles.btnTxt}>简体中文</p>
          </div>

          <div
            className={`${styles.btn} ${styles.lastBtn}`}
            onClick={onPressKo}
          >
            {langCode=='ko' &&
              <AiOutlineCheck
                size={isWide? '1em' : '0.7em'}
                color={'white'}
              />
            }
            <p className={styles.btnTxt}>한국어</p>
          </div>

        </>
        }

      </div>
    </>
  );
}


export default ChangeLanguage;